/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import { useDispatch, useSelector } from 'react-redux'; // Importing hooks for Redux dispatch and selector
import {useEffect, useState, useRef} from 'react'; // Importing React hooks
import { useTranslation } from 'react-i18next';
import {calculateHeight, errorMsg, isSmWidth} from "../../../../../../../Apis/functions";
import routes from "../../../../../../../Routes/routes";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {STATUS_MODEL} from "../../../../../../../enums/statusEnum";
import {
    GetAttendanceAdjustmentGroupById
} from "../../../../../../../reduxToolkit/AttendanceAdjustment/AttendanceAdjustmentApi";
import {FILE_MODEL} from "../../../../../Visitor/Visitor/Model/Model";

const SubmissionHistoryDetailsApp = () => {
    const navigate = useNavigate(); // Initialize navigate function for routing
    const { t } = useTranslation(); // Translation hook to handle language translations
    const dispatch = useDispatch(); // Redux dispatch hook
    const { id } = useParams();
    const location = useLocation();
    const { state } = location; // Get state from location
    const DEV = useSelector((state) => state?.CommonsSlice?.development); // Accessing development data from Redux store
    const { permission } = useSelector((state) => state.authenticatioauthennSlice); // Accessing user permissions from Redux store
    const { isAttendanceSupervisor } = useSelector((state) => state.AttendancePersistSlice);
    const containerCardRef = useRef(null);
    const containerTableRef = useRef(null);
    const contentCardRef = useRef(null);
    const contentTableRef = useRef(null);
    const [item, setItem] = useState(null);
    const [evidence, setEvidence] = useState([]);
    const showBadge = (item?.approvalStatusId && item?.approvalStatusId !== STATUS_MODEL.PENDING_REVIEW);

    useEffect(() => {
        if (isSmWidth()) return;
        const bottom = showBadge ? 80 : 70;
        calculateHeight({elementRef: containerCardRef, bottom:bottom});
        calculateHeight({elementRef: containerTableRef, bottom:bottom});
        calculateHeight({elementRef: contentCardRef, bottom:bottom});
        calculateHeight({elementRef: contentTableRef, bottom:bottom});
    }, [showBadge]);

    // useEffect hook to load data when component mounts or updates
    useEffect(() => {
        getInfo();
    }, []); // Dependency array to trigger re-fetching on update

    const getInfo = () => {
        dispatch(GetAttendanceAdjustmentGroupById(id)).then(
            ({
                 payload: {
                     data: { data, success, code },
                 }
             }) => {
                if (success) {
                    setItem(data);
                    const aux = data?.evidence?.map(e => FILE_MODEL.set(e));
                    if(aux) setEvidence(aux);
                }else errorMsg(code);
            }
        );
    };

    const goBack = () => {
        if(state?.backUrl){
            navigate(state.backUrl, {
                state: {
                    currentTab: state?.currentTab,
                    currentSubView: state?.currentSubView,
                    // The list is filtered by a date range, so it travels back with the tab
                    // to rebuild the view the user came from.
                    submissionHistoryFilters: state?.submissionHistoryFilters
                }
            });
        } else {
            navigate(routes.attendance.main)
        }
    }

    return {
        t,
        navigate,
        DEV,
        permission,
        contentCardRef,
        contentTableRef,
        containerCardRef,
        containerTableRef,
        item,
        goBack,
        evidence,
        showBadge,
        isAttendanceSupervisor
    };
};

export default SubmissionHistoryDetailsApp; // Exporting the component for use in other parts of the app
